/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationOptionVo
 */
export interface LocationOptionVo {
    /**
     * 货位ID
     * @type {number}
     * @memberof LocationOptionVo
     */
    locationId?: number;
    /**
     * 货位号
     * @type {string}
     * @memberof LocationOptionVo
     */
    locationNo?: string;
    /**
     * 货架使用类型
     * @type {number}
     * @memberof LocationOptionVo
     */
    useType?: number;
    /**
     * 货架尺寸类型
     * @type {number}
     * @memberof LocationOptionVo
     */
    sizeType?: number;
}

/**
 * Check if a given object implements the LocationOptionVo interface.
 */
export function instanceOfLocationOptionVo(value: object): value is LocationOptionVo {
    return true;
}

export function LocationOptionVoFromJSON(json: any): LocationOptionVo {
    return LocationOptionVoFromJSONTyped(json, false);
}

export function LocationOptionVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationOptionVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'useType': json['useType'] == null ? undefined : json['useType'],
        'sizeType': json['sizeType'] == null ? undefined : json['sizeType'],
    };
}

export function LocationOptionVoToJSON(json: any): LocationOptionVo {
    return LocationOptionVoToJSONTyped(json, false);
}

export function LocationOptionVoToJSONTyped(value?: LocationOptionVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'locationNo': value['locationNo'],
        'useType': value['useType'],
        'sizeType': value['sizeType'],
    };
}

